<template>
  <div>
    <v-row class="mb-0">
      <v-col cols="12" sm="6" md="6" lg="6">
        <v-col cols="auto">
          <!-- Reload button -->
          <v-btn small color="secondary" @click.stop="init()">
            <v-icon left>
              mdi-cached
            </v-icon> 
            Reload
          </v-btn>
        </v-col>
      </v-col>
      <v-col cols="12" sm="6" md="6" lg="6">
        <v-card-title class="pa-0">
          <v-spacer></v-spacer>
          <v-text-field v-model="filter" append-icon="search" label="Search" single-line hide-details></v-text-field>
        </v-card-title>
      </v-col>
    </v-row>
    <div :key="revIdx" v-for="(revItem, revIdx) in revMeetingSections">
      <h3 class="pa-0 ma-0">{{revItem.title}}</h3>
      <v-divider class="ma-0 mt-3"></v-divider>
      <!-- view, edit mode -->
      <v-row class="mt-0 mb-1 pb-2 text-right">
        <v-col class="text-left" cols="12" xs="6" md="6" justify="left" align="left" pt-0>
          <!-- <v-row>
            <v-col cols="auto">
              <v-checkbox
                class="mt-0"
                v-model="reviewMeetingFilters.showPastData"
                label="Show Past Data"
                color="secondary"
                :value="false"
                hide-details
                @change="init()"
              ></v-checkbox>
            </v-col>
            <v-col cols="auto">
              <v-checkbox
                class="mt-0"
                v-model="reviewMeetingFilters.showEmptyReviewDate"
                label="Show Empty Review Dates"
                color="secondary"
                :value="false"
                hide-details
                @change="init()"
              ></v-checkbox>
            </v-col>
          </v-row> -->
        </v-col>
        <v-col class="text-right" cols="12" xs="6" md="6" justify="right" align="right" pt-0>
          <v-btn color="secondary" small @click="changeModeCustom('edit', revItem)" v-if="revItem.currentMode === 'view'">
            <v-icon v-on="on" small>edit</v-icon>
            Edit Mode
          </v-btn>
          <v-btn color="error" small @click="changeModeCustom('view', revItem)" v-if="revItem.currentMode === 'edit'">
            Close Edit
          </v-btn>
          <!-- <v-btn color="success" small :disabled="disableSave" @click="saveChanges()" v-if="currentMode === 'edit'">
            <v-icon v-on="on" small>check</v-icon>
            Save Changes
          </v-btn> -->
        </v-col>
      </v-row>
      <!-- BEGIN vue data table -->
      <div style="margin-bottom:30px!important">
        <v-data-table
        dense
        :headers="headers"
        :search="filter"
        :items="revItem.data"
        :items-per-page="10"
        class="review-meeting-table elevation-1">
          <template v-slot:[`item.name`]="{ item }">
            <td class="text-start" style="width:300px">
              <div>
                <p class="text-left mb-0">
                  {{item.name}}
                </p>
              </div>
            </td>
          </template>
          <template v-slot:[`item.AM`]="{ item }">
            <td class="text-start" style="width:200px">
              <div>
                <p class="text-left mb-0">
                  {{item.AM}}
                </p>
              </div>
            </td>
          </template>
          <template v-slot:[`item.CC`]="{ item }">
            <td class="text-start" style="width:200px">
              <div>
                <p class="text-left mb-0">
                  {{item.CC}}
                </p>
              </div>
            </td>
          </template>
          <template v-slot:[`item.reviewMeetingDate`]="{ item }">
            <td class="text-start" style="min-width:200px">
              <div v-if="revItem.currentMode === 'view'">
                <p class="text-left mb-0">
                  {{item.reviewMeetingDate}}
                </p>
              </div>
              <div v-if="revItem.currentMode === 'edit'">
                <!-- Add Review Meeting -->
                <add-review-meeting-date
                :oldReviewDate="item.reviewMeetingDate"
                :campaignID="item.id"
                :options="{theme: 'tableview'}"
                @updated="invokeReviewMeetingUpdated(item, ...arguments)"/>
              </div>
            </td>
          </template>
          <template v-slot:[`item.sentimentDueDate`]="{ item }">
            <td class="text-start date-columns">
              <div v-if="item.sentimentDueDate">
                <div class="d-flex flex-row" style="justify-content:right;">
                  <div class="col-checkbox-label">
                    <v-chip
                      small
                      color="red"
                      text-color="white"
                      v-if="showOverdueLabel(item.sentimentDueDate, item.SentimentDateCol.status)"
                    >
                      {{item.sentimentDueDate}}
                    </v-chip>
                    <!-- <v-chip
                      small
                      color="green"
                      text-color="white"
                      v-else-if="item.SentimentDateCol.status"
                    >
                      {{item.sentimentDueDate}}
                    </v-chip> -->
                    <p class="text-left mb-0" v-else>
                      {{item.sentimentDueDate}}
                    </p>
                  </div>
                  <div>
                    <v-checkbox
                      class="mt-0"
                      v-model="item.SentimentDateCol.status"
                      color="secondary"
                      :value="false"
                      :disabled="!sentimentDateColAllow"
                      @change="changeCheckBox(item, 'SentimentDateCol')"
                      hide-details
                    ></v-checkbox>
                  </div>
                </div>
                <v-btn
                  class="btn-view-review-deck"
                  v-if="item.SentimentDateCol.reviewDateURL"
                  :href="item.SentimentDateCol.reviewDateURL"
                  target="_blank"
                  color="secondary"
                  v-bind="attrs"
                  v-on="on"
                  small
                  text
                >
                  <v-icon class="mr-0" x-small left>remove_red_eye</v-icon>
                  <span>View Review Deck</span>
                </v-btn>
              </div>
            </td>
          </template>
          <template v-slot:[`item.ccDeckReadyDate`]="{ item }">
            <td class="text-start date-columns">
              <div v-if="item.ccDeckReadyDate">
                <div class="d-flex flex-row" style="justify-content:right;">
                  <div class="col-checkbox-label">
                    <v-chip
                      small
                      color="red"
                      text-color="white"
                      v-if="showOverdueLabel(item.ccDeckReadyDate, item.CCReadyDeckCol.status)"
                    >
                      {{item.ccDeckReadyDate}}
                    </v-chip>
                    <!-- <v-chip
                      small
                      color="green"
                      text-color="white"
                      v-else-if="item.CCReadyDeckCol.status"
                    >
                      {{item.ccDeckReadyDate}}
                    </v-chip> -->
                    <p class="text-left mb-0" v-else>
                      {{item.ccDeckReadyDate}}
                    </p>
                  </div>
                  <div>
                    <v-checkbox
                      class="mt-0"
                      v-model="item.CCReadyDeckCol.status"
                      color="secondary"
                      :value="false"
                      :disabled="!ccReadyDeckColAllow"
                      @change="changeCheckBox(item, 'CCReadyDeckCol')"
                      hide-details
                    ></v-checkbox>
                  </div>
                </div>
              </div>
            </td>
          </template>
          <template v-slot:[`item.amDeckReadyDate`]="{ item }">
            <td class="text-start date-columns">
              <div v-if="item.amDeckReadyDate">
                <div class="d-flex flex-row" style="justify-content:right;">
                  <div class="col-checkbox-label">
                    <v-chip
                      small
                      color="red"
                      text-color="white"
                      v-if="showOverdueLabel(item.amDeckReadyDate, item.AMReadyDeckCol.status)"
                    >
                      {{item.amDeckReadyDate}}
                    </v-chip>
                    <!-- <v-chip
                      small
                      color="green"
                      text-color="white"
                      v-else-if="item.AMReadyDeckCol.status"
                    >
                      {{item.amDeckReadyDate}}
                    </v-chip> -->
                    <p class="text-left mb-0" v-else>
                      {{item.amDeckReadyDate}}
                    </p>
                  </div>
                  <div>
                    <v-checkbox
                      class="mt-0"
                      v-model="item.AMReadyDeckCol.status"
                      color="secondary"
                      :value="false"
                      :disabled="!amReadyDeckColAllow"
                      @change="changeCheckBox(item, 'AMReadyDeckCol')"
                      hide-details
                    ></v-checkbox>
                  </div>
                </div>
              </div>
            </td>
          </template>
          <template v-slot:[`item.overallAlignmentDate`]="{ item }">
            <td class="text-start date-columns">
              <div v-if="item.overallAlignmentDate">
                <div class="d-flex flex-row" style="justify-content:right;">
                  <div class="col-checkbox-label">
                    <v-chip
                      small
                      color="red"
                      text-color="white"
                      v-if="showOverdueLabel(item.overallAlignmentDate, item.overallAlignmentCol.status) && !item.overallAlignmentCol.status"
                    >
                      {{item.overallAlignmentDate}}
                    </v-chip>
                    <!-- <v-chip
                      small
                      color="green"
                      text-color="white"
                      v-else-if="item.overallAlignmentCol.status"
                    >
                      {{item.overallAlignmentDate}}
                    </v-chip> -->
                    <p class="text-left mb-0" v-else>
                      {{item.overallAlignmentDate}}
                    </p>
                  </div>
                  <div>
                    <v-checkbox
                      class="mt-0"
                      v-model="item.overallAlignmentCol.status"
                      color="secondary"
                      :value="false"
                      :disabled="!overallAlignmentColAllow"
                      @change="changeCheckBox(item, 'overallAlignmentCol')"
                      hide-details
                    ></v-checkbox>
                  </div>
                </div>
              </div>
            </td>
          </template>
          <template v-slot:[`item.approvedByAdmin`]="{ item }">
            <td class="text-start date-columns">
              <div v-if="item.approvedByAdminCol && !reviewMeetingFilters.showEmptyReviewDate">
                <div class="d-flex flex-row" style="justify-content:center;">
                  <div>
                    <v-checkbox
                      class="mt-2"
                      v-model="item.approvedByAdminCol.status"
                      color="green"
                      :value="false"
                      :disabled="!approvedByAdminAllow"
                      @change="changeCheckBox(item, 'approvedByAdminCol')"
                      hide-details
                    ></v-checkbox>
                  </div>
                  <div class="col-checkbox-label" v-if="item.approvedByAdminCol.status">
                    <p class="text-left mb-0">
                      Review Completed
                    </p>
                  </div>
                </div>
              </div>
            </td>
          </template>
          <template v-slot:[`item.feedback`]="{ item }">
            <td class="text-start" style="width:150px">
              <div>
                <v-btn
                  v-if="item.feedbackForm"
                  :to="'/client/feedback-form?id='+item.feedbackForm.id"
                  target="_blank"
                  color="success"
                  v-bind="attrs"
                  v-on="on"
                  small
                  text
                >
                  <v-icon left>remove_red_eye</v-icon>
                  <span>View Form</span>
                </v-btn>
                <v-tooltip
                v-if="!item.feedbackForm && item.AM && item.CC"
                right
                :open-on-hover="false"
                v-model="item.linkCopied">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      @click="copyFeedbackLink(item)"
                      color="secondary"
                      v-bind="attrs"
                      v-on="on"
                      small
                      text
                    >
                      <v-icon left>mdi-content-copy</v-icon>
                      <span>Copy Link</span>
                    </v-btn>
                  </template>
                  <span><v-icon color="white darken-2">mdi-check-all</v-icon> Copied</span>
                </v-tooltip>
              </div>
            </td>
          </template>
          <template v-slot:no-data>No Data</template>
        </v-data-table>
      </div>
    </div>
    <!-- End of Review Meeting Sections -->

    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="true"
      loader="bars"
      background-color="#000"
      color="secondary"
      width.number="90"
      height.number="90"
    ></loading>
    <input type="hidden" id="copy-link" :value="feedbackLink">
    <!-- Review Deck URL Modal Dialog -->
    <review-deck-url-modal
    v-model="reviewDeckURLDialog"
    :value="reviewDeckURLDialog"
    :item="reviewDeckItem"
    :dateCol="reviewDateCol"
    @saveClicked="saveReviewDeckURL"
    @closeClicked="closeReviewDeckModal"
    />
    <!-- Review Meeting Checklists Dialog -->
    <review-meeting-checklist-modal
    v-model="checkListsDialog"
    :value="checkListsDialog"
    :item="checkItem"
    :dateCol="checkCol"
    @saveClicked="saveReviewMeetingCheckList"
    @closeClicked="closeCheckListModal"
    />
  </div>
</template>
<script>
import moment from 'moment';
import { mapState } from 'vuex'
import config from '@/config';
import reviewMeetingConfig from './config'
import userAPIs from '../../User/userAPIs';
import campaignAPIs from '../../Campaign/campaignAPIs';
import AddReviewMeetingDate from '../Timeline/AddReviewMeetingDate'
import ReviewDeckUrlModal from './ReviewDeckUrlModal';
import ReviewMeetingChecklistModal from './ReviewMeetingChecklistModal';
import ViewEditMode from '@/mixins/ViewEditMode'
import orderBy from 'lodash/orderBy';
import utils from '@/utils'
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
export default {
  name: 'UpComingReviewMeetingDataTable',
  props: ['refresh'],
  mixins: [ViewEditMode],
  components: {
    AddReviewMeetingDate,
    ReviewDeckUrlModal,
    ReviewMeetingChecklistModal,
    Loading
  },
  data() {
    return {
      headers: reviewMeetingConfig.tableHeaders,
      AM: [],
      CC: [],
      filteredItems: [],
      revMeetingSections: [],
      revMeetingSectionTypes: {
        new: 0,
        processing: 1,
        completed: 2
      },
      reviewDeckItem: {},
      reviewDateCol: '',
      checkItem: {},
      checkCol: '',
      filter: '',
      reviewMeetingFilters: {
        showPastData: false,
        showEmptyReviewDate: false
      },
      feedbackLink: '',
      reviewDeckURLDialog: false,
      checkListsDialog: false,
      disableSave: false,
      isLoading: false
    }
  },
  computed: {
    ...mapState({
      campaigns: state => state.campaign.campaigns,
      reviewMeetings: state => state.campaignTimeline.reviewMeetings,
      savedReviewMeeting: state => state.campaignTimeline.savedReviewMeeting
    }),
    overallAlignmentColAllow() {
      return this.currentUserRole === config.userRoles.SUPER_ADMIN_HIGH || this.currentUserRole === config.userRoles.ACCOUNT_MANAGER
    },
    amReadyDeckColAllow() {
      return this.currentUserRole === config.userRoles.SUPER_ADMIN_HIGH || this.currentUserRole === config.userRoles.ACCOUNT_MANAGER
    },
    ccReadyDeckColAllow() {
      return this.currentUserRole === config.userRoles.SUPER_ADMIN_HIGH || this.currentUserRole === config.userRoles.AD_STRATEGIST
    },
    sentimentDateColAllow() {
      return this.currentUserRole === config.userRoles.SUPER_ADMIN_HIGH || this.currentUserRole === config.userRoles.AD_STRATEGIST
    },
    approvedByAdminAllow() {
      return this.currentUserRole === config.userRoles.SUPER_ADMIN_HIGH
    },
    currentUserRole() {
      return Number(this.$store.state.user.role);
    },
    currentUserID() {
      return this.$store.state.user.id;
    }
  },
  watch: {
    refresh(value) {
      if (value) this.init()
    }
  },
  async mounted() {
    this.init()
  },
  methods: {
    async init() {
      this.isLoading = true
      await this.getUsers()
      // await this.$store.dispatch('campaign/paginateCampaigns', {
      //   filters: {
      //     status: -1,
      //     forceRoleCheck: true,
      //     sort: 'updatedAt DESC'
      //   }
      // })
      // this.filteredItems = Object.assign([], this.campaigns)
      this.resetRevMeetingSections()
      await this.$store.dispatch('campaignTimeline/getReviewMeetingLists', {
        filters: {}
      })
      for (const [key, value] of Object.entries(this.revMeetingSections)) {
        let items = Object.assign([], this.reviewMeetings)
        items = await this.setFeedbackForms(items)
        items = this.beautifyCampaignData(items, value.type)
        this.revMeetingSections[key].data = Object.assign([], items)
      }
      this.isLoading = false
    },
    beautifyCampaignData(items, type) {
      // impl beautify campaign data here
      items = items.map(item => {
        item.AM = this.AM.filter(am => item.assignedTo && item.assignedTo.includes(am.id)).map(am => am.name).join(', ')
        item.CC = this.CC.filter(co => item.assignedTo && item.assignedTo.includes(co.id)).map(co => co.name).join(', ')
        let campaignTimeline = item.reviewmeetings.find(t => t.campaignID === item.id)
        item.overallAlignmentCol = campaignTimeline && campaignTimeline.overallAlignmentCol || { status: false }
        item.AMReadyDeckCol = campaignTimeline && campaignTimeline.AMReadyDeckCol || { status: false }
        item.CCReadyDeckCol = campaignTimeline && campaignTimeline.CCReadyDeckCol || { status: false }
        item.SentimentDateCol = campaignTimeline && campaignTimeline.SentimentDateCol || { status: false }
        item.approvedByAdminCol = campaignTimeline && campaignTimeline.approvedByAdminCol || { status: false }
        if (campaignTimeline && campaignTimeline.reviewMeetingDate) {
          const meetingReviewDates = {
            reviewMeetingDate: campaignTimeline.reviewMeetingDate,
            overallAlignmentDate: campaignTimeline.overallAlignmentDate,
            amDeckReadyDate: campaignTimeline.amDeckReadyDate,
            ccDeckReadyDate: campaignTimeline.ccDeckReadyDate,
            statsReadyByLivePostsDate: campaignTimeline.statsReadyByLivePostsDate,
            statsReadyByReviewMeetingDate: campaignTimeline.statsReadyByReviewMeetingDate
          }
          item = this.getMeetingReviewDates(meetingReviewDates, item)
        }
        return item
      })
      // filters made on frontend coz need to both pass records with empty records in filters
      const todayDate = moment().format('YYYY-MM-DD')
      // filter for NEW
      if (type === this.revMeetingSectionTypes.new) {
        items = items.filter(item => item.minContentMeet && !item.reviewMeetingDate)
      }
      // filter for processing
      if (type === this.revMeetingSectionTypes.processing) {
        let clonedItems = Object.assign([], items)
        let upcomingItems = clonedItems.filter(c => utils.func.parseDate(c.reviewMeetingDate) >= todayDate && !this.isRevCompleted(c))
        let pastItems = clonedItems.filter(c => utils.func.parseDate(c.reviewMeetingDate) < todayDate && !c.feedbackForm && !this.isRevCompleted(c))
        pastItems = orderBy(pastItems, ['reviewMeetingDateSortFormat'], ['asc'])
        items = Object.assign([], upcomingItems)
        items = orderBy(items, ['reviewMeetingDateSortFormat'], ['asc'])
        items.push(...pastItems)
      }
      // filter for completed
      if (type === this.revMeetingSectionTypes.completed) {
        items = items.filter(item => {
          if (this.isRevCompleted(item)) return true
          return false
        })
      }
      return items

      // // filter records less than tdy date for past data
      // if (this.reviewMeetingFilters.showPastData && !this.reviewMeetingFilters.showEmptyReviewDate) {
      //   this.filteredItems = this.filteredItems.filter(f => utils.func.parseDate(f.reviewMeetingDate) < todayDate && f.feedbackForm)
      // }
      // // filter for empty review dates
      // if (this.reviewMeetingFilters.showEmptyReviewDate && !this.reviewMeetingFilters.showPastData) {
      //   this.filteredItems = this.filteredItems.filter(f => !f.reviewMeetingDate)
      // }
      // // if both less than tdy date and empty filters
      // if (this.reviewMeetingFilters.showPastData && this.reviewMeetingFilters.showEmptyReviewDate) {
      //   this.filteredItems = this.filteredItems.filter(f => (utils.func.parseDate(f.reviewMeetingDate) < todayDate && f.feedbackForm) || !f.reviewMeetingDate)
      // }
      // // if no filters, get dates greater than tdy and past date with feedback form
      // if (!this.reviewMeetingFilters.showPastData && !this.reviewMeetingFilters.showEmptyReviewDate) {
      //   let clonedItems = Object.assign([], this.filteredItems)
      //   let upcomingItems = clonedItems.filter(c => utils.func.parseDate(c.reviewMeetingDate) >= todayDate)
      //   let pastItems = clonedItems.filter(c => utils.func.parseDate(c.reviewMeetingDate) < todayDate && !c.feedbackForm)
      //   pastItems = orderBy(pastItems, ['reviewMeetingDateSortFormat'], ['asc'])
      //   this.filteredItems = Object.assign([], upcomingItems)
      //   this.filteredItems = orderBy(this.filteredItems, ['reviewMeetingDateSortFormat'], ['asc'])
      //   this.filteredItems.push(...pastItems)
      // } else {
      //   this.filteredItems = orderBy(this.filteredItems, ['reviewMeetingDateSortFormat'], ['asc'])
      // }
    },
    getMeetingReviewDates(meetingReviewDates, item) {
      item.reviewMeetingDate = meetingReviewDates.reviewMeetingDate
      item.reviewMeetingDateSortFormat = utils.func.parseDate(meetingReviewDates.reviewMeetingDate)
      item.overallAlignmentDate = meetingReviewDates.overallAlignmentDate
      item.amDeckReadyDate = meetingReviewDates.amDeckReadyDate
      item.ccDeckReadyDate = meetingReviewDates.ccDeckReadyDate
      item.statsReadyByLivePostsDate = meetingReviewDates.statsReadyByLivePostsDate
      item.statsReadyByReviewMeetingDate = meetingReviewDates.statsReadyByReviewMeetingDate

      item.sentimentDueDate = utils.func.getLatestDate(
        utils.func.parseDate(meetingReviewDates.statsReadyByLivePostsDate),
        utils.func.parseDate(meetingReviewDates.statsReadyByReviewMeetingDate),
        'DD/MM/YYYY'
      )
      // if sentimentDueDate greater than cc deck ready date
      const formattedDeckReadyDate = utils.func.parseDate(item.ccDeckReadyDate)
      const formattedSentimentDate = utils.func.parseDate(item.sentimentDueDate)
      if (formattedSentimentDate > formattedDeckReadyDate) {
        item.sentimentDueDate = item.ccDeckReadyDate
      }
      return item
    },
    async invokeReviewMeetingUpdated(item, value) {
      let itemIdx = this.filteredItems.indexOf(item)
      this.filteredItems[itemIdx] = this.getMeetingReviewDates(value, item)
      this.filteredItems = utils.func.refreshJSON(this.filteredItems)
      this.filteredItems = orderBy(this.filteredItems, ['reviewMeetingDateSortFormat'], ['asc'])
    },
    async saveChanges(saveItems = []) {
      saveItems = saveItems.map(item => {
        return {
          campaignID: item.id,
          overallAlignmentCol: item.overallAlignmentCol || null,
          AMReadyDeckCol: item.AMReadyDeckCol || null,
          CCReadyDeckCol: item.CCReadyDeckCol || null,
          SentimentDateCol: item.SentimentDateCol || null,
          approvedByAdminCol: item.approvedByAdminCol || null,
          dueDates: {
            reviewMeetingDate: item.reviewMeetingDate,
            sentimentDueDate: item.sentimentDueDate,
            ccDeckReadyDate: item.ccDeckReadyDate,
            amDeckReadyDate: item.amDeckReadyDate,
            overallAlignmentDate: item.overallAlignmentDate
          },
          checkChgCol: item.chgCol || null
        }
      })
      let formData = new FormData()
      formData.append('data', JSON.stringify(saveItems));
      await this.$store.dispatch('campaignTimeline/saveReviewMeeting', formData)
      // if (this.savedReviewMeeting) {
      //   this.currentMode = 'view'
      //   this.$swal({
      //     text: 'Successfully Saved.',
      //     type: 'success'
      //   })
      // }
    },
    async saveReviewDeckURL(item) {
      item[this.reviewDateCol].status = true
      await this.saveChanges([item])
      this.setItem(item)
    },
    async closeReviewDeckModal(item) {
      this.setItem(item)
    },
    async saveReviewMeetingCheckList(item) {
      item[this.checkCol].status = true
      await this.saveChanges([item])
      this.setItem(item)
    },
    async closeCheckListModal(item) {
      this.setItem(item)
    },
    setItem(item) {
      let items = Object.assign([], this.filteredItems)
      this.filteredItems = []
      setTimeout(() => {
        this.filteredItems = items.map(fItem => {
          if (fItem.id === item.id) {
            fItem = Object.assign({}, item)
          }
          return fItem
        })
      }, 0)
    },
    async getUsers() {
      let response = null
      // Get all AM by role
      response = await userAPIs.getAllUsersByRole(config.userRoles.ACCOUNT_MANAGER)
      if (response) {
        this.AM = response.users
        this.AM = this.AM.map(am => {
          am.name = `${am.firstName} ${am.lastName}`
          return am
        })
      }
      this.AM.unshift({id: '', name: 'All Team'})
      // Get all CC by role
      response = await userAPIs.getAllUsersByRole(config.userRoles.AD_STRATEGIST)
      if (response) {
        this.CC = response.users
        this.CC = this.CC.map(cc => {
          cc.name = `${cc.firstName} ${cc.lastName}`
          return cc
        })
        this.CC.unshift({id: '', name: 'All Team'})
      }
    },
    async setFeedbackForms(items) {
      const response = await campaignAPIs.getClientFeedbacks({})
      let feedbacksForms = response.feedbacks
      items = items.map(item => {
        let matchForm = feedbacksForms.find(f => f.campaignID === item.id)
        if (matchForm) item.feedbackForm = matchForm
        return item
      })
      return items
    },
    async copyFeedbackLink(campaign) {
      try {
        const state = await campaignAPIs.getFeedbackAccess(campaign.id)
        if (!state.accepting || !state.token) {
          this.$swal({ title: 'Feedback is closed.', type: 'info' })
          return
        }
        this.feedbackLink = `${window.location.origin}${config.CLIENT_FEEDBACK_FORM_URL}/${campaign.id}#token=${encodeURIComponent(state.token)}`
        setTimeout(function() { campaign.linkCopied = utils.func.copyToClipboard('#copy-link') }, 100)
      } catch (error) {
        this.$swal({ title: 'Unable to create feedback link', type: 'error' })
      }
    },
    changeCheckBox(item, colName) {
      if (!this.checkPreviousStage(item, colName)) {
        return
      }
      item.chgCol = colName
      let chgCol = item[colName]
      chgCol.userID = this.currentUserID
      chgCol.createdAt = moment().toISOString()
      if (chgCol.status && colName === 'SentimentDateCol') {
        // if sentiment date col, show review date dialog
        this.reviewDateCol = colName
        this.reviewDeckItem = Object.assign({}, item)
        this.reviewDeckURLDialog = true
      } else if (chgCol.status) {
        this.checkCol = colName
        this.checkItem = Object.assign({}, item)
        this.checkListsDialog = true
      } else {
        delete chgCol.reviewDateURL
        this.saveChanges([item])
      }
      this.filteredItems = utils.func.refreshJSON(this.filteredItems)
    },
    showOverdueLabel(checkDate, checked) {
      if (!checkDate || checked) return false
      const todayDate = moment().format('YYYY-MM-DD')
      let formattedDate = utils.func.parseDate(checkDate)
      return todayDate > formattedDate
    },
    checkPreviousStage(item, colName) {
      let errorColName = ''
      let isError = false
      if (colName === 'CCReadyDeckCol' && item.CCReadyDeckCol.status && !item.SentimentDateCol.status) {
        isError = true
        errorColName = 'Stats and Sentiment Due Date'
        item.CCReadyDeckCol.status = false
      } else if (colName === 'AMReadyDeckCol' && (item.CCReadyDeckCol && !item.CCReadyDeckCol.status)) {
        isError = true
        errorColName = 'Completed by CC'
        item.AMReadyDeckCol.status = false
      } else if (colName === 'overallAlignmentCol' && (item.AMReadyDeckCol && !item.AMReadyDeckCol.status)) {
        isError = true
        errorColName = 'Completed by AM'
        item.overallAlignmentCol.status = false
      }
      // else if (colName === 'approvedByAdminCol' && (item.overallAlignmentCol && !item.overallAlignmentCol.status)) {
      //   isError = true
      //   errorColName = 'Alignment Sync'
      //   item.approvedByAdminCol.status = false
      // }
      if (isError) {
        this.setItem(item)
        this.$swal({
          text: `Please complete "${errorColName}".`,
          type: 'warning'
        })
        return false
      }
      return true
    },
    resetRevMeetingSections() {
      this.revMeetingSections = [{
        title: 'New',
        type: this.revMeetingSectionTypes.new,
        currentMode: 'view',
        data: []
      }, {
        title: 'Processing',
        type: this.revMeetingSectionTypes.processing,
        currentMode: 'view',
        data: []
      }, {
        title: 'Completed',
        type: this.revMeetingSectionTypes.completed,
        currentMode: 'view',
        data: []
      }]
    },
    changeModeCustom(mode, item) {
      item.currentMode = mode
    },
    isRevCompleted(item) {
      if (item.reviewMeetingDate &&
        item.overallAlignmentCol.status &&
        item.AMReadyDeckCol.status &&
        item.CCReadyDeckCol.status &&
        item.SentimentDateCol.status &&
        item.approvedByAdminCol.status) return true
      return false
    }
  }
}
</script>
<style>
  .review-meeting-table tbody td {
    border-right: 1px solid #dddddd;
    height: 50px!important;
  }
</style>
<style scoped>
  .col-checkbox-label {
    margin-top: 5px;
    margin-right: 5px;
  }
  .edit-date-box {
    max-width: 150px;
  }
  .date-columns {
    width: 160px;
  }
  .btn-view-review-deck {
    font-size: 10px!important;
    height: 20px!important;
    margin-bottom: 5px;
    padding-right: 0!important;
  }
</style>



// WEBPACK FOOTER //
// DataTable.vue?0092a32f